const tokenKey = 'access-token'
export default class auth {
  /**
   * 获取localStorage中的token
   */
  public static getToken(): string | null {
    return localStorage.getItem(tokenKey)
  }

  /**
   * 保存token到localStorage中
   * @param token
   */
  public static setToken(token: string): void {
    localStorage.setItem(tokenKey, token)
  }

  /**
   * 移除localStorage中的token
   */
  public static clearToken(): void {
    return localStorage.removeItem(tokenKey)
  }

  /**
   * 从提取响应头中的token并保存到缓存中
   * @param headers 响应头
   */
  public static pickToken(headers: any): void {
    const token = headers['access-token'];// 固定key
    if (token) {
      this.setToken(token);
    }
  }

  /**
   * 按照jwt标准格式往请求头中写入token
   * @param headers 请求头
   */
  public static appendToken(headers: any): void {
    const token = this.getToken()
    if (token) {
      headers['Authorization'] = `Bearer ${token}`
    }
  }
}

export interface AuthStatic {
  /**
   * 获取localStorage中的token
   */
  getToken(): string | null

  /**
   * 保存token到localStorage中
   * @param token
   */
  setToken(token: string): void

  /**
   * 移除localStorage中的token
   */
  clearToken(): void

  /**
   * 从提取响应头中的token并保存到缓存中
   * @param headers 响应头
   */
  pickToken(headers: any): void

  /**
   * 按照jwt标准格式往请求头中写入token
   * @param headers 请求头
   */
  appendToken(headers: any): void
}
